import { devicesTypeValues } from '../../../../Shared/utils.js'

import {
  allReportingColumns, globalColumns, hardwareColumns, deviceWipeColumns, diskWipeColumns, testsHardwareColumns, allDiagnosticColumns, deploymentColumns,
  sbarColumns, imagingColumns, manualInputsColumns, tradeInColumns, welcomScreenColumns, hexadecimalViewerColumns,
  globalColumnsMobiles, hardwareColumnsMobiles, locksColumnsMobiles, operationsColumnsMobiles, manualInputsColumnsMobiles, otherColumnsMobiles, subHardwareColumnsMobiles,
  testsColumnsMobiles, disksWipeColumns, scriptsColumns, bootImageColumns, allManualInputsColumns, locksColumns
} from '../../../../Shared/reporting.js';


export const getAllAvailableColumns = (
  scenario, 
  welcomeScreenManualInputs, sdsQuestions, scriptHeaders, mobileOthersData,
  sdsExtraDiskHealthFlag, sdsExtraDiskPerfFlag
) => {

  let allAvailableColId = [];

  let categories;
  if (scenario && scenario.devicesType === devicesTypeValues.PCs) {

    // general
    for (const col of globalColumns) {
      const colId = `general_$$_${col}`;
      allAvailableColId.push(colId);
    }

    // hardware
    categories = Object.entries(allReportingColumns).filter(key => hardwareColumns.includes(key[0])).map(([title, columns]) => [title, columns]);
    if (categories) {
      for (const category of categories) {
        for (const col of category[1]) {
          // if (col === 'computed_health') {
          //   if (sdsExtraDiskHealthFlag) {
          //     const colId = `${category[0]}_$$_${col}`;
          //     allAvailableColId.push(colId);
          //   }
          // }
          // else if (col === 'computed_perf') {
          //   if (sdsExtraDiskPerfFlag) {
          //     const colId = `${category[0]}_$$_${col}`;
          //     allAvailableColId.push(colId);
          //   }
          // }
          // else {
          const colId = `${category[0]}_$$_${col}`;
          allAvailableColId.push(colId);
          // }          
        }
      }
    }

    // device wipe
    for (const col of deviceWipeColumns) {
      const colId = `device_wipe_$$_${col}`;
      allAvailableColId.push(colId);
    }

    // disk_wipe
    for (const col of diskWipeColumns) {
      const colId = `disk_wipe_$$_${col}`;
      allAvailableColId.push(colId);
    }

    // imaging
    for (const col of imagingColumns) {
      const colId = `imaging_$$_${col}`;
      allAvailableColId.push(colId);
    }

    // deployments
    for (const col of deploymentColumns) {
      const colId = `deployments_$$_${col}`;
      allAvailableColId.push(colId);
    }

    // sbar
    for (const col of sbarColumns) {
      const colId = `sbar_$$_${col}`;
      allAvailableColId.push(colId);
    }

    // diagnostics
    categories = Object.entries(allDiagnosticColumns).filter(key => testsHardwareColumns.includes(key[0])).map(([title, columns]) => [title, columns]);
    if (categories) {
      for (const category of categories) {
        for (const col of category[1]) {
          const colId = `${category[0]}_$$_${col}`;
          allAvailableColId.push(colId);
        }
      }
    }

    // trade_in
    for (const col of tradeInColumns) {
      const colId = `trade_in_$$_${col}`;
      allAvailableColId.push(colId);
    }

    // Manual Inputs
    categories = Object.entries(allManualInputsColumns).filter(key => manualInputsColumns.includes(key[0])).map(([title, columns]) => [title, columns]);
    if (categories) {
      for (const category of categories) {
        for (const col of category[1]) {
          const colId = `${category[0]}_$$_${col}`;

          if (colId === "manual_input_$$_questions_form" && sdsQuestions) {
            sdsQuestions.sort(function (a, b) {
              if (a.xtra_id < b.xtra_id) {
                return -1;
              }
              if (a.xtra_id > b.xtra_id) {
                return 1;
              }
              return 0;
            }).map(question => {
              const newColId = colId + "_$$_Question#" + question.xtra_id
              allAvailableColId.push(newColId);
            })
          }
          else if (colId === "questions_form_$$_question_value" && sdsQuestions) {
            sdsQuestions.sort(function (a, b) {
              if (a.xtra_id < b.xtra_id) {
                return -1;
              }
              if (a.xtra_id > b.xtra_id) {
                return 1;
              }
              return 0;
            }).map(question => {
              if (question.xtra_id !== null) {
                const newColId = colId + "_$$_question#" + question.xtra_id + "_$$_" + question.xtra_desc;
                allAvailableColId.push(newColId);
              }
            })
          }
          else if (colId === "welcome_screen_$$_input_value" && welcomeScreenManualInputs) {
            welcomeScreenManualInputs.sort(function (a, b) {
              if (a.xtra_id < b.xtra_id) {
                return -1;
              }
              if (a.xtra_id > b.xtra_id) {
                return 1;
              }
              return 0;
            }).map(question => {
              if (question.xtra_id !== null) {
                const newColId = colId + "_$$_input#" + question.xtra_id + "_$$_" + question.xtra_desc;
                allAvailableColId.push(newColId);
              }
            })
          }
          else
            allAvailableColId.push(colId);
        }
      }
    }

    // script
    for (const col of scriptsColumns) {
      const colId = `script_$$_${col}`;
      if (colId === "script_$$_script_value" && scriptHeaders) {

        scriptHeaders.map(script => {
          const newColId = colId + "_$$_script#" + script
          allAvailableColId.push(newColId);
        });
      }
      else
        allAvailableColId.push(colId);
    }

    // bootimage
    for (const col of bootImageColumns) {
      const colId = `bootimage_$$_${col}`;
      allAvailableColId.push(colId);
    }

    // hexadecimal_viewer
    for (const col of hexadecimalViewerColumns) {
      const colId = `hexadecimal_viewer_$$_${col}`;
      allAvailableColId.push(colId);
    }

    // locks
    for (const col of locksColumns) {
      const colId = `locks_$$_${col}`;
      allAvailableColId.push(colId);
    }

  }
  else if (scenario && scenario.devicesType === devicesTypeValues.mobiles) {

    // general_mobiles
    for (const col of globalColumnsMobiles) {
      const colId = `general_mobiles_$$_${col}`;
      allAvailableColId.push(colId);
    }

    // hardware mobile
    categories = Object.entries(subHardwareColumnsMobiles).filter(key => hardwareColumnsMobiles.includes(key[0])).map(([title, columns]) => [title, columns]);
    if (categories) {
      for (const category of categories) {
        for (const col of category[1]) {
          const colId = `${category[0]}_$$_${col}`;
          allAvailableColId.push(colId);
        }
      }
    }

    // tests_mobiles
    for (const col of testsColumnsMobiles) {
      const colId = `tests_mobiles_$$_${col}`;
      allAvailableColId.push(colId);
    }

    // locks_mobiles
    for (const col of locksColumnsMobiles) {
      const colId = `locks_mobiles_$$_${col}`;
      allAvailableColId.push(colId);
    }

    // operations_mobiles
    for (const col of operationsColumnsMobiles) {
      const colId = `operations_mobiles_$$_${col}`;
      allAvailableColId.push(colId);
    }

    // manual_inputs_mobiles
    for (const col of manualInputsColumnsMobiles) {
      const colId = `manual_inputs_mobiles_$$_${col}`;
      allAvailableColId.push(colId);
    }

    // other_mobiles
    for (const col of otherColumnsMobiles) {
      const colId = `other_mobiles_$$_${col}`;

      if (colId === "other_mobiles_$$_others_input_value" && mobileOthersData) {
        mobileOthersData.sort(function (a, b) {
          if (a.xtra_id < b.xtra_id) {
            return -1;
          }
          if (a.xtra_id > b.xtra_id) {
            return 1;
          }
          return 0;
        }).map(data => {
          if (data !== null) {
            const newColId = colId + "_$$_" + data;
            allAvailableColId.push(newColId);
          }
        })
      }
      else
        allAvailableColId.push(colId);
    }

  }
  else if (scenario && scenario.devicesType === devicesTypeValues.disks) {

    // for (const col of globalColumns) {
    //   const colId = `disks_wipe_$$_${col}`;
    //   allAvailableColId.push(colId);
    // }

    for (const col of globalColumns) {
      const colId = `general_$$_${col}`;
      allAvailableColId.push(colId);
    }

    for (const col of disksWipeColumns) {
      const colId = `disks_wipe_$$_${col}`;
      allAvailableColId.push(colId);
    }

    

    // hardware mobile
    categories = Object.entries(allManualInputsColumns).filter(key => manualInputsColumns.includes(key[0])).map(([title, columns]) => [title, columns]);
    if (categories) {
      for (const category of categories) {
        for (const col of category[1]) {
          const colId = `${category[0]}_$$_${col}`;

          if (colId === "manual_input_$$_questions_form" && sdsQuestions) {
            sdsQuestions.sort(function (a, b) {
              if (a.xtra_id < b.xtra_id) {
                return -1;
              }
              if (a.xtra_id > b.xtra_id) {
                return 1;
              }
              return 0;
            }).map(question => {
              const newColId = colId + "_$$_Question#" + question.xtra_id
              allAvailableColId.push(newColId);
            })
          }
          else if (colId === "questions_form_$$_question_value" && sdsQuestions) {
            sdsQuestions.sort(function (a, b) {
              if (a.xtra_id < b.xtra_id) {
                return -1;
              }
              if (a.xtra_id > b.xtra_id) {
                return 1;
              }
              return 0;
            }).map(question => {
              if (question.xtra_id !== null) {
                const newColId = colId + "_$$_question#" + question.xtra_id + "_$$_" + question.xtra_desc;
                allAvailableColId.push(newColId);
              }
            })
          }
          else if (colId === "welcome_screen_$$_input_value" && welcomeScreenManualInputs) {
            welcomeScreenManualInputs.sort(function (a, b) {
              if (a.xtra_id < b.xtra_id) {
                return -1;
              }
              if (a.xtra_id > b.xtra_id) {
                return 1;
              }
              return 0;
            }).map(question => {
              if (question.xtra_id !== null) {
                const newColId = colId + "_$$_input#" + question.xtra_id + "_$$_" + question.xtra_desc;
                allAvailableColId.push(newColId);
              }
            })
          }
          else
            allAvailableColId.push(colId);
        }
      }
    }
  }
  // console.log("305 - allAvailableColId=", allAvailableColId);

  return allAvailableColId;

}